module.exports = __webpack_public_path__ + "img/homeHeader.43a694d7.jpg";